<template>
	
	<div class="page1_main_layout">
		产品2
	</div>
	<Footer></Footer>

</template>

<script>
	import request from "@/utils/request";
	import { ElNotification } from 'element-plus'
	import Footer from '@/components/Footer'
	
	export default{
		name:"page4",
		components:{
			Footer
		},
		data() {
			return{
				base_url:SERVER_URL,
				one_user_detail:{},
				one_user_detail_isShow:false,
				user_detail_list:[],
				add_new_user:false,
			}
		},
		mounted(){
			// request.get(this.$GLOBAL.flask_web_local_url+'/get_map_data_info').then(res => {
			// 	console.log(res)
			// })
			document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_1', 'rgba(255, 255, 255, 0.4)')
			document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_2', 'rgba(255, 255, 255, 0.4)')
			document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_3', 'rgba(255, 255, 255, 0.4)')
			document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_4', 'rgba(85, 255, 255, 0.7)')
			document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_5', 'rgba(255, 255, 255, 0.4)')
			document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_6', 'rgba(255, 255, 255, 0.4)')
			
			this.get_user_datail_list()
			
		},
		methods:{
			get_user_datail_list(){
				let temp_user_layout_list = []
				for(let i=0;i<23;i++){
					temp_user_layout_list.push({
						id:"user_layout_"+(i+1),
						username:"user_layout_"+(i+1),
						name:"QQQ"+i,
						phone:11111111111+i,
						sex:'男'
						
					})
				}
				this.user_detail_list = temp_user_layout_list
			},
			show_one_user_detail(item){
				this.add_new_user = false
				this.one_user_detail = {}
				for(let i in item){
					this.one_user_detail[i] = item[i]
				}
				if(!this.one_user_detail_isShow){
					this.one_user_detail_isShow = true
				}
			},
			close_one_user_detail(){
				this.one_user_detail_isShow = false
				this.add_new_user = false
			},
			save_one_user_data(){
				for(let i in this.user_detail_list){
					if(this.user_detail_list[i].id == this.one_user_detail.id){
						for(let j in this.one_user_detail){
							this.user_detail_list[i][j] = this.one_user_detail[j] 
							
						}
					}
				}
			    ElNotification({
			      title: '修改成功',
			      message: '账号 '+ this.one_user_detail.username + ' 数据修改成功！',
			      type: 'success',
			    })
			},
			delete_one_user_data(){
				let temp_data_list = []
				for(let i in this.user_detail_list){
					if(this.user_detail_list[i].id != this.one_user_detail.id){
						temp_data_list.push(this.user_detail_list[i])
					}
				}
				this.user_detail_list = temp_data_list
				ElNotification({
				  title: '删除成功',
				  message: '账号 '+ this.one_user_detail.username + ' 成功删除！',
				  type: 'success',
				})
				this.one_user_detail_isShow = false
			},
			add_new_user_data(){
				let check_data = false
				if(this.one_user_detail.username&&this.one_user_detail.name&&this.one_user_detail.sex&&this.one_user_detail.phone&&this.one_user_detail.password){
					check_data = true
				}
				if(check_data){
					let temp_new_user = {}
					for(let i in this.one_user_detail){
						temp_new_user[i] = this.one_user_detail[i]
					}
					temp_new_user['id'] = this.one_user_detail.username
					this.user_detail_list.push(temp_new_user)
					ElNotification({
					  title: '创建成功',
					  message: '账号 '+ this.one_user_detail.username + ' 创建成功！',
					  type: 'success',
					})
					this.one_user_detail_isShow = false
				}else{
					ElNotification({
					  title: '创建失败',
					  message: '数据不能为空或数据格式错误，请重新创建！',
					  type: 'error',
					})
				}

			},
			add_new_user_btn(){
				this.add_new_user = true
				this.one_user_detail_isShow = true
				this.one_user_detail = {}
				console.log(this.user_detail_list)
			}
		}
	}
</script>

<style>
</style>